import { createSelector } from 'reselect';
import BalanceModificationTransactionsColumns from '../../containers/BalanceModificationTransactionsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.BALANCE_MODIFICATION_TRANSACTIONS.isLoading;
export const getData = TableDefinitions.BALANCE_MODIFICATION_TRANSACTIONS.getDataFunction();
export const getColumns = createSelector(getData, BalanceModificationTransactionsColumns);
